import { I18n } from 'i18n-js'
import React from 'react'
import { v4 } from 'uuid'

import translations from './de.json'

const i18n = new I18n()

i18n.store(translations)
i18n.locale = 'de'

type TranslationOptions = Record<string, string | number>
export type Translation = (translation: string, options?: TranslationOptions) => string

export const t: Translation = i18n.t.bind(i18n)

export function scopedTranslation (scope: string) {
  const scopedT = (translation: string, options?: TranslationOptions) =>
    t(`${scope}.${translation}`, options)
  const scopedHtmlT = (translation: string, options?: TranslationOptions) => (
    // eslint-disable-next-line @typescript-eslint/naming-convention
    <span dangerouslySetInnerHTML={{ __html: scopedT(translation, options) }} />
  )

  return { htmlT: scopedHtmlT, t: scopedT }
}

export function isPresent (element: any): boolean {
  return element !== null && element !== undefined
}

export function isTrue (str: unknown): boolean {
  return str === 'true'
}

export function booleanInLocalStorage (key: string, value?: boolean): boolean {
  if (value === undefined) {
    return isTrue(localStorage.getItem(key))
  }
  if (!value) {
    localStorage.removeItem(key)
  }
  if (value) {
    localStorage.setItem(key, 'true')
  }

  return value
}

export function uniqueClassName () {
  return v4().replace(/^[\d-]+/u, '')
}

export function navigateTo (url: string) {
  window.location.href = url
}

export function openEmptyTab () {
  return window.open()
}

export function navigateRelative (url: string) {
  window.location.href = `${window.location.href}/${url}`.replace(/\/\/`/gu, '/')
}

export function checkDatesMatching (date: Date, reference = new Date()): boolean {
  return date.getFullYear() === reference.getFullYear() &&
    date.getMonth() === reference.getMonth() &&
    date.getDate() === reference.getDate()
}

export function isToday (date: Date): boolean {
  return checkDatesMatching(date)
}

export function isCurrentDate (date: Date | number, reference: Date | number): boolean {
  const currentDate = new Date(date)
  const referenceDate = new Date(reference)

  return checkDatesMatching(currentDate, referenceDate)
}
